import { apiFetch } from "./http";
// Kayıtlı profiller — kullanıcı GSPR wizard'da bir profili isimle DB'ye kaydeder.
// Sonradan PresetAccordion gibi listeden seçip uygulayabilir.
import type { ProductProfile } from "./gspr";

const API_BASE = "/api/v1/saved-profiles";

export type SavedProfile = {
  id: string;
  name: string;
  profile: ProductProfile;
  created_at: string;
  updated_at: string;
};

export type SavedProfileListResponse = {
  count: number;
  profiles: SavedProfile[];
};

export async function listSavedProfiles(): Promise<SavedProfileListResponse> {
  const res = await apiFetch(`${API_BASE}/`);
  if (!res.ok) throw new Error(`listSavedProfiles: HTTP ${res.status}`);
  return res.json();
}

export async function createSavedProfile(name: string, profile: ProductProfile): Promise<SavedProfile> {
  const res = await apiFetch(`${API_BASE}/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name, profile }),
  });
  if (!res.ok) {
    const body = await res.text();
    throw new Error(`createSavedProfile: HTTP ${res.status} — ${body}`);
  }
  return res.json();
}

export async function deleteSavedProfile(id: string): Promise<void> {
  const res = await apiFetch(`${API_BASE}/${id}`, { method: "DELETE" });
  if (!res.ok && res.status !== 404) throw new Error(`deleteSavedProfile: HTTP ${res.status}`);
}
